import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Text, View, TextInput } from 'react-native';
import PhoneInput from "react-native-phone-number-input";
import { Colors } from '../components';

class PhoneNumberInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      phone_input_border: 'white'
    }

    this.phoneInput = React.createRef();

    this.on_phone_change = this.on_phone_change.bind(this);
  }

  on_phone_change(phone_number) {
    let isValid = this.phoneInput.isValidNumber(phone_number);

    console.log('phone numb isValid', isValid, phone_number);

    let change_action = this.props.onChangeText;
    change_action(phone_number, isValid);
  }

  render() {
    let value         = this.props.value || '';
    let placeholder   = this.props.placeholder || '';
    let passed_style  = this.props.style || {};

    return (
      <PhoneInput
        ref={node=>{this.phoneInput = node}}
        style={{ borderRadius: 15 }}
        textInputProps={{
          onFocus: () => { this.setState({ phone_input_border: Colors.PRIMARY }) },
          onBlur:  () => { this.setState({ phone_input_border: 'white' }) }
        }}
        textInputStyle={{ outlineColor: 'white', outline: 'none', backgroundColor: 'white', width: 100 }}
        textContainerStyle={{ borderRadius: 10, borderBottomLeftRadius: 0, borderTopLeftRadius: 0, backgroundColor: 'white', paddingLeft: 10 }}
        containerStyle={{ borderRadius: 10, width: 310, borderWidth: 2, borderColor: this.state.phone_input_border }}
        countryPickerButtonStyle={{ width: 80 }}
        placeholder={placeholder}
        defaultValue={value}
        defaultCode="US"
        layout="first"
        onChangeText={this.on_phone_change}
        onChangeFormattedText={this.on_phone_change}
        withDarkTheme
        withShadow
        autoFocus
      />
    );
  }

}

const styles = StyleSheet.create({
  default_style: {
    borderWidth: 1,
    borderColor: 'grey',
    padding: 15,
    borderRadius: 12
  }
});

export default PhoneNumberInput
